import React from "react";
import {Link} from "react-router-dom";
import {Previsione, FASE_COLLEZIONE} from "./previsioniSlice";
import {Routes_path} from "components/routerApp";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import {theme} from "../../../theme";

import DeleteIcon from "@mui/icons-material/Delete";
import Checkbox from "@mui/material/Checkbox";
import PrevisioniInlineForm from "./PrevisioniInlineForm";
import Tooltip from "@mui/material/Tooltip";
import AllegatiPreview from "../../../allegati/AllegatiPreview";

// ============================================
// INTERFACES
// ============================================

interface PrevisioniRigaProps {
    previsione: Previsione;
    onDelete: (previsione: Previsione) => void;
    selectable?: boolean;
    selected?: boolean;
    onToggleSelect?: (id: number) => void;
}

// ============================================
// COMPONENT
// ============================================

const PrevisioniRiga = ({previsione, onDelete, selectable, selected, onToggleSelect}: PrevisioniRigaProps) => {
    // @ts-ignore
    // @ts-ignore
    return (
        <Card
            sx={{
                marginBottom: theme.spacing(1),
                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: theme.shadows[4],
                },
            }}
        >
            <CardContent sx={{py: 1}}>
                <Grid container spacing={2} alignItems="center">
                    {selectable && (
                        <Grid size={{xs: 0.5, lg: 0.3}}>
                            <Checkbox
                                size="small"
                                checked={!!selected}
                                onChange={() => previsione.id && onToggleSelect?.(previsione.id)}
                            />
                        </Grid>
                    )}
                    <Grid size={{xs: 1, lg: 0.5}}>
                        <Typography variant="body2">
                            {previsione.stagione_display || '-'}
                        </Typography>
                    </Grid>

                    <Grid size={{xs: 2, lg: 1}}>
                        <Typography variant="body2">
                            {previsione.mandatario_display || '-'}
                        </Typography>
                    </Grid>

                    <Grid size={{xs: 2, lg: 1}}>
                        <Link
                            to={`${Routes_path.PREVISIONE}${previsione.id}`}
                            style={{textDecoration: 'none'}}
                        >
                            <Tooltip sx={{background:'transparent'}}
                                title={
                                    <AllegatiPreview key={previsione.id} previsione_id={previsione.id}/>
                            }>
                                <Typography
                                    color="primary"
                                    variant="body2"
                                    fontWeight="bold"
                                    sx={{
                                        display: 'inline-block',
                                        padding: '2px 8px',
                                        borderRadius: 1,
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                            fontWeight: 800,
                                            backgroundColor: 'rgba(5, 118, 210, 0.20)',
                                        }
                                    }}
                                >
                                    {previsione.codice_item || '-'}
                                </Typography>
                            </Tooltip>
                        </Link>
                    </Grid>

                    <Grid size={{xs: 3, lg: selectable ? 2.7 : 3}}>
                        <Typography variant="body2">
                            {previsione.descrizione_item || '-'}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {previsione.articolo_cliente}
                        </Typography>
                    </Grid>

                    <Grid size={{xs: 2, lg: 1}}>
                        <Typography variant="body2">
                            {previsione.brand_display || '-'}
                        </Typography>
                    </Grid>

                    <Grid size={{xs: 2, lg: 1}}>
                        <Typography variant="body2">
                            {previsione.confezionista_display || '-'}
                        </Typography>
                    </Grid>

                    <Grid size={{xs: 1, lg: 1}}>
                        <Typography variant="body2">
                            {previsione.tecnica_display || '-'}
                        </Typography>
                    </Grid>

                    <Grid size={{xs: 1, lg: 0.5}}>
                        <Typography variant="body2">
                            {previsione.px_prod != null
                                ? `€ ${Intl.NumberFormat("it-IT", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }).format(Number(previsione.px_prod))}`
                                : "-"}
                        </Typography>
                    </Grid>

                    {/* Form inline per Fase Collezione*/}
                    <Grid size={{xs: 2, lg: 1.5}}>
                        <PrevisioniInlineForm
                            previsione={previsione}
                            onlyField="fase_collezione"
                        />
                    </Grid>

                    {/* Form inline per Quantità BDG*/}
                    <Grid size={{xs: 1, lg: 1}}>
                        <PrevisioniInlineForm
                            previsione={previsione}
                            onlyField="qta_bdg"
                        />
                    </Grid>

                    <Grid size={{xs: 1, lg: 0.5}}>
                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation();
                                onDelete(previsione);
                            }}
                            size="small"
                            color="error"
                        >
                            <DeleteIcon fontSize="small"/>
                        </IconButton>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default PrevisioniRiga;